import { Button } from '@/components/V3/Button';
import { isMobileState } from '@/store/atom';

import { useRecoilState } from 'recoil';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useWebview from '@/hooks/V3/useWebview';
import { ROUTES } from '@/routes';

const ControllerSection = () => {
  const navigate = useNavigate();
  const { postMessage } = useWebview();
  const [searchParams] = useSearchParams();

  const [isMobile] = useRecoilState(isMobileState);

  // app에서 사용하는 회원가입 이후 첫 진입인지 판단하는 변수
  const isFirst = searchParams.get('isFirst') === 'true';

  const navigateAdaptively = ({ destination }: { destination?: string }) => {
    if (!isMobile) {
      navigate(destination || ROUTES.market);
    } else {
      postMessage({
        action: 'resetApp',
        data: {
          index: 0,
          routes: destination
            ? [
                {
                  key: 'MainTab',
                  name: 'MainTab',
                  params: {
                    screen: 'More',
                  },
                },
                {
                  key: destination,
                  name: destination,
                  params: {
                    isFirst: isFirst,
                  },
                },
              ]
            : [
                {
                  key: 'MainTab',
                  name: 'MainTab',
                  params: {
                    screen: 'Home',
                  },
                },
              ],
        },
      });
    }
  };
  return (
    <div className=" flex w-full max-w-[335px] space-x-[9px]">
      <Button
        variant="SolidLow"
        className={`flex-1 ${isMobile ? '' : 'hidden'}`}
        onClick={() => navigateAdaptively({ destination: 'MarketInfo' })}
      >
        마켓 추가 연동
      </Button>
      <Button variant="SolidHigh" className="flex-1" onClick={() => navigateAdaptively({})}>
        홈으로
      </Button>
    </div>
  );
};

export default ControllerSection;
